<template>
    <div>
        <div class="card-body sent-mail-container">
            <div class="email-event-failed alert alert-danger" v-if="email.failed_event && !email.delivered_event">
                <span class="label label-danger">{{ email.failed_event.event | capitalize }}</span>
                <span class="pull-right">
                    <span class="mytooltip tooltip-effect-2" v-if="email.failed_event.reason">
                        <span class="tooltip-item"><i class="mdi mdi-help-circle-outline"></i></span>
                        <span class="tooltip-content flow-root">
                            <span class="tooltip-text pl-2">{{ email.failed_event.reason }}</span>
                        </span>
                    </span>
                    Email delivery failed
                </span>
            </div>
            <div class="d-flex mb-4">
                <div class="px-2 overflow-auto flex-grow-1 line-height-2">
                    <h5 v-if="email.from_name !== undefined" class="mb-0">
                        {{ email.from_name }}
                    </h5>
                    <small v-if="email.from_name !== undefined" class="text-muted">
                        From: {{ email.from }}
                    </small>
                    <h5 v-if="email.from_name === undefined" class="mb-0">
                        {{ email.from }}
                    </h5>
                    <small class="text-muted">
                        To: {{ email.to }}
                    </small>
                    <small v-if="email.cc" class="text-muted">
                        cc:{{ email.cc }}
                    </small>
                    <small v-if="email.bcc" class="text-muted">
                        bcc:{{ email.bcc }}
                    </small>
                    <div>
                        <a class="attachment" v-for="attachment in email.media" :href="attachment.url" target="_blank">
                            <small>{{ attachment.file_name }}</small>
                        </a>
                    </div>
                </div>
                <div class="pr-2 line-height-2" style="min-width: 100px;">
                    <small class="text-muted" v-if="email.sent_at">{{ email.sent_at | datetime }}</small>
                </div>
                <div>
                    <el-dropdown trigger="click" @command="handleCommand">
                        <el-button size="mini">
                            <i class="mdi mdi-dots-horizontal"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="forwardEmail">Forward</el-dropdown-item>
                            <el-dropdown-item command="viewEmailEvents" v-if="fromInboxDashboard">Email Events</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="p-2 sent-mail-content" v-html="safeEmailBody(email.body)"></div>
            <div class="flow-root"></div>
            <span v-if="email.delivered_event" class="p-2 text-muted">
                Delivered to {{ email.to_name !== null ? email.to_name : "Customer" }} on {{ email.delivered_event.event_timestamp | datetime }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: ["email", "fromInboxDashboard"],
    methods: {
        safeEmailBody (html) {
            let temp = document.createElement("div");
            temp.innerHTML = html;
            let elements = temp.getElementsByTagName("style");
            if (elements.length > 0) {
                while (elements[0])
                    elements[0].parentNode.removeChild(elements[0]);
            }
            return temp.innerHTML;
        },
        handleCommand (command) {
            if (command === "forwardEmail") {
                this.$emit("forward-email", this.email.id);
            }
            if (command === "viewEmailEvents") {
                this.$emit("view-email-events", this.email.id);
            }
        }
    }
};
</script>

<style>
.attachment {
    background: #f3f7f8;
    padding: 3px 4px;
    margin-right: 5px;
    border-radius: 5px;
    color: #33b5e5;
    display: inline-block;
}

.sent-mail-container {
    border-left: 3px solid #33b5e5;
    border-bottom: 1px solid #f2f7f8;
}

.sent-mail-content, .sent-mail-content p {
    margin-bottom: 0;
    white-space: pre-line !important;
}

blockquote {
    padding: 15px;
    border: none;
    border-left: #efefef 3px solid;
}

.email-event-failed {
    border-radius: 0;
    border: none;
    border-right: 3px solid;
}

.email-event-tooltip {
    color: #b11623 !important;
}

.tooltip-item {
    background: transparent !important;
}

.line-height-2 {
    line-height: 2;
}
</style>
